import s from "./PaymentMethod.module.css";

import React from "react";

import { InnerHtmlSVG } from "@common/InnerHtmlSVG";


const PaymentMethod = ({itsActive, element, btnText, setActive}) => {
  return (
    <button
      className={itsActive ? s.bankCard + " " + s.active : s.bankCard}
      onClick={() => setActive(element.name)}
    >
      <div className={s.img}>
        <InnerHtmlSVG svg={element.svg}/>
      </div>

      <div className={s.bankCardText}>
        <div className={s.bankCardTitle}>{element.title}</div>
        <div className={s.bankCardSubTitle}>{btnText}</div>
      </div>
    </button>
  );
};

export default PaymentMethod;
